import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { PatientImmunizations } from '~/features/demographics/immunizations/PatientImmunizations';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientImmunizationsRoute() {
	const { stayId } = useChart();
	return (
		<Section header={<SectionTitle title="Immunizations" />}>
			<PatientImmunizations stayId={stayId} />
		</Section>
	);
}
